// eslint-disable-next-line unicorn/prefer-module
const getWindowUrl = require('./getWindowUrl');

const PREFIX_REGEX = /^https?:\/\/[^/]+/;

const getOriginWithPrefix = (requestUrl) => {
  const url = requestUrl || getWindowUrl();

  const [originWithPrefix] = url.match(PREFIX_REGEX);
  return originWithPrefix;
};

// eslint-disable-next-line unicorn/prefer-module
module.exports = getOriginWithPrefix;
